var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductGirl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Product_-_girl",
    "data-name": "Product - girl",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 116.161,
    height: 116.852,
    viewBox: "0 0 116.161 116.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9332",
    "data-name": "Rectangle 9332",
    width: 116.161,
    height: 116.852,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58297",
    "data-name": "Group 58297",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87298",
    "data-name": "Path 87298",
    d: "M76.191,147.659c-.356-1.426,2.839-4.431,4.457-5.526,2.071-1.4,6.029-1.978,8.558-1.783.348,1.308,1.791,2.2,2.541,3.2,1.04,1.382,2.35,2.376,3.52,3.655,1.123,1.226,2.119,2.791,3.244,3.789a7.094,7.094,0,0,1,2.639,4.689c.574,4.281-3.388,6.774-6.775,8.557a10.755,10.755,0,0,1-4.1,1.426c-2.826.523-5.17,1.248-6.552-1.039-3.294-5.452-5.185-10.826-7.532-16.789",
    transform: "translate(-29.286 -53.952)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87299",
    "data-name": "Path 87299",
    d: "M82.072,76.136s-9.866,23.557-19.41,29.912c0,0-9.85,8.171-18.211,4.774,0,0,.313-19,5.515-23.009,0,0,16.61-16.7,32.106-11.676",
    transform: "translate(-17.092 -28.912)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87300",
    "data-name": "Path 87300",
    d: "M35.542,35.821s9.018,10.944,10.33,17.71c0,0,1.243,6.937-2.869,10.293,0,0-7.7-4.178-8.741-8.023,0,0-5.6-13.394,1.281-19.981",
    transform: "translate(-12.348 -13.774)",
    fill: "#afdb71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87301",
    "data-name": "Path 87301",
    d: "M.046,102.158s15.033,4.969,20.559,9.183c0,0,5.583,4.39,4.491,9.771,0,0-.982,3.041-4.356.848,0,0-21.878-10.067-20.693-19.8",
    transform: "translate(0 -39.281)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87302",
    "data-name": "Path 87302",
    d: "M91.668,1.406S84.365,14.232,79.5,17.528c0,0-4.992,3.267-7.791-.276a7.772,7.772,0,0,1,2.6-5.876s10.706-8.484,17.356-9.97",
    transform: "translate(-27.574 -0.541)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87303",
    "data-name": "Path 87303",
    d: "M8.093,51.877S21.612,60.823,26.4,70.8c0,0,6.432,12.961,1.939,20.4,0,0-14.57-5.242-17.711-10.761,0,0-9.632-14.593-2.535-28.563",
    transform: "translate(-2.109 -19.947)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87304",
    "data-name": "Path 87304",
    d: "M101.378,38.913S88.2,53.42,78.716,56.561c0,0-9.759,3.081-15.966-1.872,0,0,3.686-11.365,8.986-13.548,0,0,17.836-10.317,29.641-2.228",
    transform: "translate(-24.128 -13.772)",
    fill: "#afdb71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87305",
    "data-name": "Path 87305",
    d: "M48.33,0s9.536,10.577,11.24,17.8c0,0,1.646,7.417-2.193,11.76,0,0-7.831-3.357-9.086-7.414,0,0-6.321-13.813.039-22.142",
    transform: "translate(-17.493)",
    fill: "#9acb54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87306",
    "data-name": "Path 87306",
    d: "M44.624,116.3l-3.687-.218a146.742,146.742,0,0,0-.284-17.06c-.545-9.678-1.108-19.685,1.983-30.552,2.473-8.694,5.778-14.447,8.974-20.01,4.25-7.4,7.92-13.788,8.667-25.727l3.686.231c-.8,12.8-4.856,19.861-9.15,27.336-3.085,5.37-6.275,10.922-8.624,19.181-2.922,10.269-2.4,19.53-1.848,29.334a149.449,149.449,0,0,1,.284,17.485",
    transform: "translate(-15.467 -8.741)",
    fill: "#456a70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87307",
    "data-name": "Path 87307",
    d: "M29.736,163.667H46.648c1.157,0,2.01.59,1.742,1.2l-6.165,14.162a1.909,1.909,0,0,1-1.743.752H20.167a1.908,1.908,0,0,1-1.742-.752L12.259,164.87c-.267-.614.586-1.2,1.742-1.2Z",
    transform: "translate(-4.695 -62.932)",
    fill: "#001a2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87308",
    "data-name": "Path 87308",
    d: "M107.246,87.98c-.887.651-.793,3.487-.5,4.577a8.176,8.176,0,0,0,4.566,5.086c2.656,1.25,4.046.734,5.382,3.5.838,1.737,2.633,7.078,5.437,6.677.076-1.237-3.689-3.7-3.46-4.888a23.01,23.01,0,0,0,.694-3.122c.121-2.2.3-4.825-.928-6.693-1.006-1.535-3.485-1.436-5.17-1.985-1.278-.416-2.472-1.09-3.7-1.626a7.222,7.222,0,0,1-2.5-1.24",
    transform: "translate(-40.965 -33.829)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87309",
    "data-name": "Path 87309",
    d: "M181.437,173.924a4.462,4.462,0,0,1,3.063-.277c1.052.486.408,1.59.408,2.485,0,1.528-.039,4.308-1.633,5.182-.688.377-4.529,1.952-3.91-.122.225-.755,1.71-1.124,2.072-1.907a6.729,6.729,0,0,0-.1-2.7c-1.07-1.137-.215-1.483-.1-2.107",
    transform: "translate(-68.942 -66.703)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87310",
    "data-name": "Path 87310",
    d: "M133.19,173.142a5.038,5.038,0,0,1-.665,2.573,4.933,4.933,0,0,1-1.547,1.6c-.917.563-3.156,1.1-2.829,2.585,1.528.369,2.608-.336,4-.939,1.138-.491,2.443-.972,3.6-1.536,1.357-.665,1.8-1.4,1.358-2.682a10.859,10.859,0,0,0-1.838-2.443c-.428-.2-1.839.769-2.271.939",
    transform: "translate(-49.262 -66.24)",
    fill: "#2b2725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87311",
    "data-name": "Path 87311",
    d: "M109.445,88.308a6.182,6.182,0,0,0,.859,3.863,18.39,18.39,0,0,0,4.1,3.8c2.726,1.564,3.687-3.265,4.63-4.658a19.959,19.959,0,0,0-4.572-2.277,12.337,12.337,0,0,0-5.158-.87",
    transform: "translate(-42.028 -33.881)",
    fill: "#db9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87312",
    "data-name": "Path 87312",
    d: "M117.97,93.908c2.711.268,5.486,2.767,5.772,5.152.069-2.084,3.081-1.921,3.3-3.854A58.341,58.341,0,0,1,119.5,91.39c-.96.695-.576,1.158-1.677,1.659",
    transform: "translate(-45.306 -35.14)",
    fill: "#db9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87313",
    "data-name": "Path 87313",
    d: "M151.823,120.076c1.382,1.025-.027.057,1.049,1.431,1.036,1.322,2.508,2.256,3.27,3.7,2.146,4.06-.5,8.23-3.294,13.163-2.2,3.888-5.893,7.948-7.894,11.852,1.709.172,4.139.716,8.2,1.336,5.177.79,4.4.715,5.821.861,2.79.286,1.51.491,4.228.563.5.013,2.5.223,2.639.009a32.12,32.12,0,0,0-.812,3.158c-1.127-.112-2.809.305-3.578.273a37.409,37.409,0,0,0-4.8,0c-3.779,0-6.279.036-10.084-.1-3.407-.117-6.441-.4-8.415-2.192-1.446-1.315-1.209-3.8-.707-5.728a26.234,26.234,0,0,1,1.7-3.7,54.985,54.985,0,0,0,2.58-6.147,23.768,23.768,0,0,1,1.506-4.49c.344-.58.982-.755,1.625-1.187a5.155,5.155,0,0,0,1.494-1.677c1.915-2.9,3.371-1.789,3.362-5.312,0-1.464,1.976-4.824,1.336-6.105",
    transform: "translate(-52.703 -46.06)",
    fill: "#3f3936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87314",
    "data-name": "Path 87314",
    d: "M128.125,95.729c2.652.644-.014-.015,1.563,1.017,1.986,1.3,2.3,1.977,4.39,3.178a58.53,58.53,0,0,1,12.071,9.256c-1.115,1.182-3.722,3.124-4.938,4.145a10.8,10.8,0,0,0-2.058,2.21c-.671.857.5.518-.549.138-.539-.2.37-.1,0-.552-1.055-1.293-4.006-2.9-5.518-3.556-2.445-1.056-5.518.381-7.3-1.821-.881-1.085-.142-2.474.158-3.9.163-.778.081-3.869.272-5.4.1-.763,1.854-1.654,2.964-4.045",
    transform: "translate(-48.203 -36.809)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87315",
    "data-name": "Path 87315",
    d: "M140.621,116.484c4.006,3.243,9.206,8.265,4.816,14.367-2.64,3.669-7.615,4.2-11.828,4.2a80.626,80.626,0,0,1-13.266-.722,32.815,32.815,0,0,0,3.148,5.438c1.312,1.806,2.407,4.183,3.631,6.063,1.281,1.966.907,2.173,2.194,4.2,1.173,1.842-1.336-2.194-.1.286-1.949,1.1-.84.534-2.384,1.336-1.126-2.261-1.548-1.4-4.123-4.829a43.11,43.11,0,0,0-3.223-3.66c-2.671-2.957-3.488-3.175-5.576-5.959-.931-1.24-2.2-2.742-2.3-4.3-.137-2.159.323-3.122,2.25-3.857,4.006-1.526,4.244-1.335,8.68-2.48,1.866-.482,3.461-.644,5.342-1.145,1.365-.363.748-.158,4.2-.954,1.24-.286-.172-1.923.281-2.3.827-.684,7.441-5.328,8.014-6.044",
    transform: "translate(-42.908 -44.649)",
    fill: "#3f3936"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87316",
    "data-name": "Path 87316",
    d: "M61.579,157.29c2.794.222,14.888,2.347,14.888,2.347l4.68,8.545",
    transform: "translate(-23.678 -60.48)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87317",
    "data-name": "Path 87317",
    d: "M77.431,165c-1.075-3.429-2.867-5.2-6.636-5.893a42.29,42.29,0,0,0-9.525-1.033,6.615,6.615,0,0,0-.392,2.977c2.783.4,5.541,1.728,8.267,2.552,2.255.683,6.681,3.875,9.177,3.714",
    transform: "translate(-23.395 -60.769)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87318",
    "data-name": "Path 87318",
    d: "M79.973,147.544c.8-.26-.2.308.356-.356a15.607,15.607,0,0,1,3.076-2.8c1.957-1.057,3.414-1.1,5.75-1.131a17.544,17.544,0,0,1-8.469,4.466",
    transform: "translate(-30.75 -55.083)",
    fill: "#bfc6b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87319",
    "data-name": "Path 87319",
    d: "M96.617,142.823c.526-1.983.85-4.553,3.039-5.777a3.774,3.774,0,0,1,4.987,1.132c2.727,3.741.783,9.458-.744,13a2.881,2.881,0,0,1-1.2-.364c-.023-3,2.642-8.141.869-11.379-.532-.972-1.765-1.317-3.209-.357-.74.492-2,4.89-2.5,5.883-.783-.295-1.325.7-1.962,0",
    transform: "translate(-36.876 -52.502)",
    fill: "#005ca3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87320",
    "data-name": "Path 87320",
    d: "M121.465,100.626c.471.956-1.074,2.6-1.381,8.3a46.607,46.607,0,0,1-.944,5.749c-.883.836-1.605,1.537-2.8,2.548-2.24,1.9-2.964,2.544-4.486,3.894a10.8,10.8,0,0,1-3.084,2.267c-.694.235-3.989.873-2.67,1.624.5.285-.545-.154-1.254.567-.3,1.343-.23,1.325,1.032,1.868a2.527,2.527,0,0,0,2.553-.074c1.36-.735.549-1.766,1.521-2.381,1.454-.919,4.34-2.683,5.063-3.249,1.272-1,1.981-1.434,4.345-3.271,3.361-2.61,2.449-1.635,3.387-3.078a4.564,4.564,0,0,0,.687-1.821,67.825,67.825,0,0,0,1.679-6.965c.2-2.156.341-1.7.333-2.305-.012-.861.191-.788-.757-.971-.771-.148-.285-1.034-1.036-.816",
    transform: "translate(-40.259 -38.692)",
    fill: "#db9a8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87321",
    "data-name": "Path 87321",
    d: "M106.738,86.17c-.286-1.717,1.422-5.051,3.45-6.077a8.962,8.962,0,0,1,8.5.639c2.564,1.645,3.322,4.46,4.2,7.159.87,2.68,4.532,1.869,6.94,2.379,3.148.668,8.926,2.827,8.067,8.646-.148,1-.609,2.8-4.385,3.045-1.723.111-3.987-1.075-5.145-1.97a31.143,31.143,0,0,1-6.953-8.365c-.5-.911-1.618-.963-2.48-1.256a9.065,9.065,0,0,1-1.449-.573c-.583-.317-5.6-2.953-3.341-1.968.641.28-.3-.142-.975-.244-.778-.117-3.918.571-4.629.244-1.387-.636-.84-.994-1.6-2.425",
    transform: "translate(-41.03 -30.493)",
    fill: "#2b2725"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductGirl);
export default __webpack_public_path__ + "static/media/product_girl.10efaf0f1c9206be095d9a71c171bb07.svg";
export { ForwardRef as ReactComponent };